import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "uuid-fc1c0bba-527e-43d5-99a1-4b8907f9fae8",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .uuid-b4c185c4-a0bf-495f-9246-8bce13e0644a {\n        fill: #3f5fac;\n      }\n    " }) }), /* @__PURE__ */ _jsx("path", {
		className: "uuid-b4c185c4-a0bf-495f-9246-8bce13e0644a",
		d: "M74.54,27.71H26.78c-5.51,0-9.68,4.46-9.68,10.38v25.85c0,2.78.95,5.37,2.67,7.28,1.77,2,4.27,3.09,7.01,3.09l47.91-.02c5.96,0,9.49-5.09,9.49-10.02l.02-26.5c0-5.64-4.25-10.06-9.66-10.06ZM74.07,33.52l-23.43,14.14-.27-.17-23.24-13.98h46.94ZM78.39,64.4c0,2.38-1.47,4.02-3.79,4.17H26.71c-1.87-.13-3.79-1.52-3.79-3.68v-27.13l26.29,15.77c.97.51,1.92.51,2.9-.02l26.27-15.74v26.65Z"
	})]
});
export default SvgMailBlue;
